import intl from 'react-intl-universal';
import { createPortal } from 'react-dom';
import { inject, observer } from 'mobx-react';
import { message } from 'components/Dialog/Toast';
import React, { CSSProperties, useContext } from 'react';

import {
  isWeb,
  isIphoneX,
  getWatermarks,
  downloadImagesOneByOne,
} from '../../utils/util';
import { alpha } from '../../utils/color';
import imageUtil from '../../utils/image';
import RootStore from '../../store/RootStore';
import usePortalDom from '../hooks/usePortalDom';
import { IOneGallery } from '../GalleryList/Common';
import { ThemeContext } from '../../store/ThemeProvider';
import { isInMiniProgram } from '../../utils/mini_program';
import useToMiniProgramDownloadUrl from './useToMiniProgramDownloadUrl';

import './JigsawBottom.scss';

interface JigsawBottom {
  onCancel: () => void;
  onConfirm: () => void;
  type?: string; //当前的类型
  list: IOneGallery[];
  rootStore?: RootStore;
}

interface IMiniProgramBtn {
  downloadUrl: string;
  color: string;
  label: string;
  style?: CSSProperties;
  list: Array<any>;
}

export const ToMiniProgramBtn = (props: IMiniProgramBtn) => {
  const { downloadUrl, color, label, style, list = [] } = props;

  if (isInMiniProgram()) {
    const { miniProgram } = window.wx || {};
    return (
      <div
        style={{
          color: color,
          textAlign: 'center',
          flex: 1,
        }}
        onClick={() => {
          //  这儿需要判断, 如果没有, 父级组件就会提示 "至少下载一张图片"
          if (list.length === 0) {
            return;
          }
          miniProgram && miniProgram.navigateTo({ url: '/' + downloadUrl });
        }}
      >
        {label}
      </div>
    );
  }
  //  这儿需要判断, 如果没有, 父级组件就会提示 "至少下载一张图片", 如果在微信环境没有选择任何照片就跳转到小程序进行下载, 显然是不合理的
  if (list.length === 0) {
    return (
      <div style={{ color: color, textAlign: 'center', flex: 1 }}>{label}</div>
    );
  }

  return (
    <wx-open-launch-weapp
      id="launch-btn"
      username="gh_e97c78460d68"
      path={downloadUrl}
      style={Object.assign({ flex: 1 }, style)}
    >
      <script type="text/wxtag-template">
        {/*注意，需要最小宽度，否则容易出现字换行的情况， white-space:nowrap也无法解决*/}
        <div
          style={{
            color: color,
            textAlign: 'center',
          }}
        >
          {label}
        </div>
      </script>
    </wx-open-launch-weapp>
  );
};

function JigsawBottom(props: JigsawBottom) {
  const { h1Color, mainColor, componentColor } = useContext(ThemeContext);
  const { type, list } = props;
  const { galleryStore, wxuserStore } = props.rootStore!;
  const num = list.length;
  const borderColor = alpha(h1Color, 0.1);
  const getNumber = function () {
    if (num) {
      return `(${num})`;
    }
    return '';
  };

  const getScreenBottom = () => {
    return isIphoneX() ? 22 : 0;
  };

  const { downloadUrl } = useToMiniProgramDownloadUrl({
    list,
    type,
    galleryStore,
  });

  // const context = useContext(PageContext);
  const wrapper = usePortalDom({
    targetClassName: 'jigsaw-bottom-wrapper',
    // parentElement:window.document.getElementById(`page-bottom-${context.cid}`)! as HTMLDivElement
    parentElement: window.document.getElementById(
      `root-modal`
    )! as HTMLDivElement,
  });

  const renderOkButton = () => {
    if (type == 'download') {
      // 查一下，是不是付完了
      const currentGalleryData = window.dataDetail
        ? window.dataDetail
        : window.gallery;
      const usePay = Number(currentGalleryData.is_pay_down) > 0;

      if (usePay) {
        const notPayed = wxuserStore.getNotPayed(list.map((it) => it.id));
        if (notPayed && notPayed.length) {
          return intl.get('Download') + getNumber();
        }
      }

      const keys = (list || []).map((it: any) => (it ? it.id : 0));
      if (isWeb()) {
        return (
          <div
            onClick={() => {
              //  如果没有选择就点击下载，那么就提示至少选择一张图片, 是父级组件的提示
              if (list.length === 0) {
                return;
              }

              //  如果是模拟用户, 那么就需要先授权
              if (wxuserStore.user.is_mock && Number(window.configDetail.active_on) == 1) {
                wxuserStore.auth();
                return false;
              }

              //  准备好下载的数据
              const downloadList = list.map((item: IOneGallery) => ({
                name: item.origin,
                url: imageUtil.style(
                  item.hash,
                  'original',
                  {
                    watermark: window.original_photo ? [] : galleryStore.getWatermarksByKey(
                      String(item.galleryid),
                      item.show_mark
                    ),
                  },
                  item.id
                ),
              }));
              //  开始下载, 这儿浏览器会提示用户是否运行下载多个文件, 点击确定就会开始下载
              props?.rootStore?.uiStore.showToast({
                content: intl.get('Downloading'),
                time: 0
              });
              downloadImagesOneByOne(downloadList).then(() => {
                props?.rootStore?.uiStore.hideToast();
                props?.rootStore?.uiStore.showToast({
                  content: intl.get('DownloadSuccess'),
                  time: 3000
                });
                galleryStore.setJigsaw({
                  bottomShow: false,
                  jigsawList: []
                });
              });
            }}
            key={`minibutton_${keys.join()}`}
            style={{
              color: num ? mainColor : h1Color,
            }}
          >
            {intl.get('Download-Pendent-Bottom') + getNumber()}
          </div>
        );
      }
      return (
        <ToMiniProgramBtn
          list={list}
          key={`minibutton_${keys.join()}`}
          downloadUrl={downloadUrl}
          color={num ? mainColor : h1Color}
          label={intl.get('Download-Pendent-Bottom') + getNumber()}
        />
      );
    } else if (type == 'share') {
      return intl.get('Share') + getNumber();
    } else {
      return intl.get('ok') + getNumber();
    }
  };

  return wrapper
    ? createPortal(
      <div
        className="jigsaw-bottom bottom-tab"
        style={{
          backgroundColor: alpha(componentColor, 1),
          paddingBottom: getScreenBottom(),
        }}
      >
        <div
          className={'tab-one'}
          style={{ borderRightColor: borderColor, color: h1Color }}
          onClick={props.onCancel}
        >
          {intl.get('cancel')}
        </div>
        <div
          className={'tab-one'}
          style={{ color: num ? mainColor : h1Color }}
          onClick={props.onConfirm}
        >
          {renderOkButton()}
        </div>
      </div>,
      wrapper
    )
    : null;
}

export default inject('rootStore')(observer(JigsawBottom));
